import { makeStyles } from '@material-ui/core'

export const useToggleFieldStyles = makeStyles(() => ({
  switch: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '65px',
    '&> label': {
      // color: "rgba(52, 52, 52, 0.7)",
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: '400',
      lineHeight: '1',
      fontSize: '.855em',
      marginTop: '2px',
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left',
    },
  },
}))
